// extracted by mini-css-extract-plugin
module.exports = {"tableBodyRoot":"TBody_tableBodyRoot__W7rip"};